<template>
    <div class="content">
        <app-header></app-header>
        <main id="page-main" style="background: rgba(var(--color-background), 1);color: rgba(var(--color-black), 1);overflow: hidden !important;height:100%;">
                <router-view @refresh="refresh()"></router-view>
                <div class="content-body" style="padding: 0px;height:100%;">


                    <section style="padding: 0px;height:100%;display: flex;flex-direction: column;" class="agenda">

                        <div class="calendar-header">

                            <div style="display:flex;align-items: center">
                                <div>
                                    <form-select label="" v-if="branches"
                                                    v-model="branch"
                                                    :options="branches"
                                                    multiple="false"
                                                    name="name"
                                                    :callback="filterByBranch"
                                                    :has-label="false"
                                                    placeholder="Institut"
                                                    color="eventBorderColor"></form-select>

                                    {{ branch }}
                                </div>
                                <div style="width:10px;"> </div>
                                <div>
                                    <form-autocomplete multiple="false"
                                                       v-model="filteredPerson"
                                                       placeholder="Employé"
                                                       @input="filterByPerson"
                                                       :service="userService"></form-autocomplete>
                                </div>
                            </div>
                            <div style="display: flex;">

                                <button @click="calendarPrevious" class="calendar-previous"><span><i class="icon icon-icon_arrow-left"></i></span></button>
                                <button @click="calendarToday"><span>Aujourd'hui</span></button>
                                <button @click="calendarNext" class="calendar-next"><span><i class="icon icon-icon_arrow-right"></i></span></button>

                                <button style="margin-left: 10px;" class="bt-gotodate">
                                    <span>
                                        <i class="icon icon-calendar"></i>
                                        <datepicker v-model="dateSearch" @selected="calendarGoToDate"></datepicker>
                                    </span>
                                </button>

                                <button @click="refresh()" style="margin-left: 10px;" class="bt-refresh"><span><i class="icon icon-icon_refresh"></i></span></button>

                            </div>
                            <div>{{ period }}</div>
                            <div>

                                <button @click="calendarChangeView('resourceTimeGridDay')"><span>Jour</span></button>
                                <button @click="calendarChangeView('resourceTimeGridWeek')"><span>Semaine</span></button>

                            </div>
                        </div>

                        <div class="calendar-header-date">
                            <span>{{ current_dates }}</span>
                        </div>

                        <div class="calendar-container" style="flex: 1;">
                        <full-calendar v-if="slots != null"
                                ref="fullCalendar"
                                :timeZone="timeZone"
                                :locales="locales"
                                :locale="locale"
                                height="parent"
                                schedulerLicenseKey="GPL-My-Project-Is-Open-Source"
                                :plugins="calendarPlugins"
                                :datesAboveResources="true"
                                resourceOrder="ord"
                                :resources="filteredSlots"
                                :views="views"
                                :header="header"
                                :defaultView="defaultView"
                                :weekends="weekends"
                                :hiddenDays="hiddenDays"
                                :allDaySlot="allDaySlot"
                                :slotDuration="slotDuration"
                                :slotLabelFormat="slotLabelFormat"
                                :minTime="minTime"
                                :maxTime="maxTime"
                                :selectable="selectable"
                                :editable="true"
                                :nowIndicator="nowIndicator"
                                :events="events"
                                @select="handleSelect"
                                @clickDate="handleSelect"
                                @eventClick="handleClick"
                                @eventDrop="handleAutoSave"
                                @eventResize="handleAutoSave"
                                @eventRender="eventRender"
                                :navLinks="true"
                                :navLinkDayClick="navLinkDayClick"
                        />
                            <span v-html="cssComputed"></span>
                        </div>

                    </section>

                </div>

        </main>
    </div>
</template>
<script>

    import BranchService from '../config/branch/BranchService.js';

    import AgendaService from './AgendaService.js';
    import ScopeService from '../scope/ScopeService.js';
    import Index from '../../layouts/Index.vue';

    import dayGridPlugin from "@fullcalendar/daygrid";
    import timeGridPlugin from '@fullcalendar/timegrid';
    import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
    import interactionPlugin from '@fullcalendar/interaction';
    import frLocale from '@fullcalendar/core/locales/fr';

    import UserService from "../scope/UserService";
    import Datepicker from 'vuejs-datepicker';

    export default {
        extends: Index,
        components:{
            Datepicker
        },
        data () {
            return {
                userService: null,
                tmpEvent: null,
                isModalVisible: false,
                nowIndicator: true,
                timeZone: 'local',//'Europe/Zurich',
                locales: [frLocale],
                locale: 'fr',
                selectable: true,
                draggable: true,
                calendarPlugins: [ timeGridPlugin, interactionPlugin, resourceTimeGridPlugin ],
                weekends: true,
                hiddenDays: [0],
                allDaySlot: false,
                slotLabelFormat: {hour: 'numeric', minute: '2-digit', hour12: false},
                minTime: '06:00',
                maxTime: '20:00',
                slotDuration: '00:15',
                defaultView: 'resourceTimeGridWeek',
                period: null,
                dateSearch: null,
                header: {
                    left: 'prev,today,next',
                    center: 'title',
                    right: 'resourceTimeGridDay,resourceTimeGridWeek,resourceTimeGridMonth'
                },
                views: {
                    resourceTimeGridFiveDay: {
                        type: 'resourceTimeGrid',
                        duration: { days: 5 },
                        buttonText: 'Semaine'
                    }
                },
                branch: null,
                branches: [],
                slots: null,
                filteredPerson: null,
                filteredSlots: null,
                current_dates: null,
                eventRender: function(info) {

                    if( info.el.querySelector('.fc-content') )
                    {
                        let paymentContent = '';

                        if( info.event.extendedProps.payment_status == 'completed' ){
                            console.log('Event',info.event)
                            paymentContent = '<span class="payment_status">Payé</span>'
                        }

                        let content = paymentContent + info.el.querySelector('.fc-content').innerHTML
                        let comment = ""

                        if( info.event.extendedProps.comment )
                        {
                            comment = '\r\n' + info.event.extendedProps.comment
                        }

                        if( info.event.extendedProps.user ){
                            info.el.querySelector('.fc-content').innerHTML = content +
                                "<div class='fc-person'>" +
                                "<i class='icon icon-icon_person'></i>" +
                                "<span class='firstname'>" + info.event.extendedProps.user.name + "</span>" +
                                "</div>";
                        }else{
                            info.el.querySelector('.fc-content').innerHTML = content + comment;
                        }

                        info.el.setAttribute('title', info.event.title + comment);


                    }

                },
                cssComputed: null
            }
        },
        mounted: function(){

            this.userService = UserService;

            ScopeService.get(this.$store.state.scope.id).then((response) => {
                this.slots = []
                this.cssComputed = '<style>.content-body{padding:0px;}';
                for(let item of response.data.slotables){
                    this.slots.push({
                        id: item.id,
                        user_id: item.user_id,
                        slotable_id: item.slotable_id,
                        title: item.name,
                        comment: item.comment,
                        editable: item.editable,
                        eventBackgroundColor: window.hexToRGBA(item.color, .6),
                        eventBorderColor: item.color,
                        ord: item.ord,
                    })
                  console.log("item.color", item.color, item.product)
                    this.cssComputed += 'th[data-resource-id="'+item.id+'"]:before{background:'+item.color+';}';
                }

                this.slotDuration = response.data.schedule_interval ? response.data.schedule_interval : '00:15'
                this.minTime = response.data.schedule_min_time ? response.data.schedule_min_time : '00:00'
                this.maxTime = response.data.schedule_max_time ? response.data.schedule_max_time : '23:00'

                this.cssComputed += '</style>';

                this.filteredSlots = this.slots

                // Set branches
                let defaultBranch = localStorage.getItem('weebox.calendar.branch');
                this.branches = response.data.branches;

                for(let item of this.branches){
                    if( defaultBranch == item.id )
                    {
                        this.branch = item;
                        break;
                    }
                }

                this.filterByBranch(this.branch);

            })




        },
        methods: {
            navLinkDayClick: function(date, jsEvent) {
                //console.log('day', date.toISOString());
                //console.log('coords', jsEvent.pageX, jsEvent.pageY);

                this.calendarGoToDate(date);
                this.calendarChangeView('resourceTimeGridDay');
            },
            filterByBranch: function(item)
            {

                if( this.slots == null ){ return false; }

                let branches = localStorage.getItem('weebox.calendar.branch') || [];

                if( item && item.id )
                {
                    branches = [item.id];
                    localStorage.setItem('weebox.calendar.branch', item.id);
                }else{
                    localStorage.removeItem('weebox.calendar.branch');
                }


                this.refresh();
            },
            filterByPerson: function(item)
            {

                this.refresh();
                //this.$refs.fullCalendar.getApi().refetchEvents();

            },
            handleSelect(e){ // Click on calendar for add an event

                var is_editable = true;
                var slots = this.getSlotByIds([e.resource.id]);

                if(slots.length > 1) {
                    slots.forEach(function(item){
                        if(item.editable){
                            is_editable = true;
                        }
                    });
                }else{
                    is_editable = slots[0].editable;
                }

                if(is_editable) {
                    this.createEvent({
                        id: null,
                        start: moment(e.start).toISOString(),//format('YYYY-MM-DD HH:mm:ss'),
                        end: moment(e.end).toISOString(),//format('YYYY-MM-DD HH:mm:ss'),
                        type: 'reservation',
                        slots: this.getSlotByIds([e.resource.id]),
                        allDay: e.allDay
                    })
                }else{
                    alert("You don't have the right permission to edit this slot")
                }
            },
            handleClick(e){

                var is_editable = false;
                var slots = this.getSlotByIds( e.event._def.resourceIds );

                if(slots.length > 1) {

                    slots.forEach(function(item){
                        if(item.editable){
                            is_editable = true;
                        }
                    });

                }else{
                    is_editable = slots[0].editable;
                }

                if(is_editable) {
                    if(e.event.startEditable === true) {

                        this.createEvent({
                            id: e.event.id,
                            title: e.event.title,
                            start: moment(e.event.start).format('YYYY-MM-DD HH:mm:ss'),
                            end: moment(e.event.end).format('YYYY-MM-DD HH:mm:ss'),
                            type: [e.event._def.extendedProps.type],
                            user: e.event._def.extendedProps.user,
                            client: e.event._def.extendedProps.client,
                            order: e.event._def.extendedProps.order,
                            allDay: e.event.allDay,
                            slots: this.getSlotByIds( e.event._def.resourceIds )
                        })

                    }else{
                        alert('You can\'t edit this event');
                    }
                }else{
                    alert("You don't have the right permission to edit this slot")
                }

            },
            handleAutoSave(e){

              let ask = confirm("Etes-vous certain de vouloir modifier cet élément ?");
              if( !ask ){
                this.refreshEvents()
                return false;
              }


              AgendaService.update(e.event.id, {
                    id: e.event.id,
                    title: e.event.name,
                    start_at: e.event.start,
                    end_at: e.event.end,
                    type: [e.event._def.extendedProps.type],
                    user: e.event._def.extendedProps.user,
                    client: e.event._def.extendedProps.client,
                    order: e.event._def.extendedProps.order,
                    slots: this.getSlotByIds( e.event._def.resourceIds ),
                    allDay: e.event.allDay,
                    autoSave: true
                }).then(response => {
                    this.refreshEvents()
                }).catch(error => {
                    console.log(error)
                    this.refreshEvents()
                });
            },
            calendarPrevious: function()
            {
                this.$refs.fullCalendar.getApi().prev()
                this.updateCurrentDates();
            },
            calendarNext: function()
            {
                this.$refs.fullCalendar.getApi().next()
                this.period = this.$refs.fullCalendar.getApi().state.dateProfile.currentRange
                this.updateCurrentDates();
            },
            calendarToday: function()
            {
                this.$refs.fullCalendar.getApi().today()
                this.updateCurrentDates();
            },
            calendarChangeView:function(str)
            {
                this.$refs.fullCalendar.getApi().changeView(str)
                this.updateCurrentDates();
            },
            calendarGoToDate: function(date)
            {
                this.$refs.fullCalendar.getApi().gotoDate(date)
            },
            updateCurrentDates: function(dates)
            {
                if( this.$refs.fullCalendar )
                {
                    dates = dates || this.$refs.fullCalendar.getApi().state.dateProfile.currentRange

                    var start = moment(dates.start);//now
                    var end = moment(dates.end).subtract(1, 'd');

                    if( end.diff(start, 'days') <= 1 )
                    {
                        this.current_dates = (start.format('dddd D MMMM YYYY')).strUcFirst();
                    }else{
                        this.current_dates = (start.format('dddd D MMMM') + " au " + end.format('dddd D MMMM YYYY')).strUcFirst();
                    }

                    this.dateSearch = dates.start;
                }
            },
            getSlotId(id){
                for(let e of this.slots){
                    if( id == e.id ){
                        return e;
                    }
                }
                return null
            },
            getSlotByIds(ids){
                let array = []
                for(let id of ids){
                    array.push(this.getSlotId(parseInt(id)))
                }
                return array
            },
            refreshEvents(){
                if( this.$refs.fullCalendar )
                {
                    this.$refs.fullCalendar.getApi().refetchEvents();
                }
            },
            refresh(){
                this.refreshEvents();
            },
            getResource: function(){
                return null;
            },
            edit: function(id, branch, filteredPerson=0){
                let name = this.$route.name + '-edit'
                this.$router.push({ name: name, params: { id: id, branchFilter:branch, personFilter:filteredPerson } });
            },
            createEvent(event) {

                var branch = this.branch;
                var filteredPerson = this.filteredPerson || 0;

                console.log("createEvent", event)

                if( event.id )
                {
                    this.edit(event.id, branch, filteredPerson)
                }else{
                    this.$router.push({
                        name: this.$route.name + '-new',
                        params: {
                            event: event,
                            branchFilter: branch,
                            personFilter: filteredPerson
                        }
                    });
                }

            },
            closeModal() {
                this.tmpEvent = null
                this.isModalVisible = false
            },
            validateModal() {
                if( this.tmpEvent.data.id ){
                  AgendaService.update(this.tmpEvent.data.id, this.tmpEvent.data).then(response => {
                        this.refreshEvents()
                        this.closeModal()
                    });
                }else{
                  AgendaService.create(this.tmpEvent.data).then(response => {
                        this.refreshEvents()
                        this.closeModal()
                    });
                }
            },
            removeEvent() {
              let ask = confirm("Etes-vous certain de vouloir supprimer cet élément ?");
              if( ask ){
                AgendaService.delete(this.tmpEvent.data.id).then(response => {
                  this.refreshEvents()
                  this.closeModal()
                });
              }
            },
            events: function(info, successCallback, failureCallback) {

                var self = this

                this.updateCurrentDates(info);

                let branches = [];
                /*
                for(let b of self.branches){
                    branches.push(b.id);
                }*/

                if( self.branch && self.branch.id ){
                    branches = [self.branch.id];
                }else{
                    for(let b of self.branches){
                        branches.push(b.id);
                    }
                }

                this.filteredSlots = []

                for(let slot of this.slots){
                    if( branches.indexOf(slot.slotable_id) >= 0 )
                    {
                        console.log("filterByBranch slot", slot.slotable_id)
                        this.filteredSlots.push(slot)
                    }
                }

              AgendaService.events({
                    start_at: info.start.valueOf(),
                    end_at: info.end.valueOf(),
                    branch: branches,
                    user_id: (self.filteredPerson) ? self.filteredPerson.id : null,
                }).then(response => {

                    let events = []
                    for(let e of response.data){
                        if( e.rendering == "background" ){
                            events.push({
                                rendering: e.rendering,
                                type: e.type,
                                start: e.start_at,
                                end: e.end_at,
                                backgroundColor: e.backgroundColor,
                                className: 'background-type-' + e.type,
                                resourceIds: e.slots
                            })
                        }else{
                            events.push({
                                id: e.id,
                                title: e.name,
                                comment: e.comment,
                                start: e.start_at,
                                end: e.end_at,
                                type: e.type,
                                user: e.user,
                                client: e.client,
                                order: e.order,
                                editable: e.editable,
                                resourceEditable: e.editable,
                                className: 'event-type-' + e.type,
                                resourceIds: e.slots,
                                allDay: e.allDay,
                                stick: e.stick,
                                payment_status: e.payment_status
                            })
                        }
                    }
                    successCallback(events);
                });

            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/agenda/Index.vue